import dynamic from "next/dynamic";
import TwoParagraphsParagraphConfig from "./two-paragraphs-paragraph-config";
import TwoParagraphsParagraphAdvancedConfig from "./two-paragraphs-paragraph-advanced-config";
const TwoParagraphsParagraphComponent = dynamic(()=>import("./two-paragraphs-paragraph-component"));
export default {
    TwoParagraphsParagraphComponent,
    TwoParagraphsParagraphConfig,
    TwoParagraphsParagraphAdvancedConfig
};
